export const getDarker = (hex: string, factor: number) => {
  if (!hex) {
    return "";
  }
  const r = Math.floor(parseInt(hex.slice(1, 3), 16) * factor);
  const g = Math.floor(parseInt(hex.slice(3, 5), 16) * factor);
  const b = Math.floor(parseInt(hex.slice(5, 7), 16) * factor);

  return `#${[r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("")}`;
};
